import { buildContentHubPublishedVideoDeepLink } from "./build-content-hub-share-page-url";

/**
 * Published deep link for one video row in a Video Grid — delegates to
 * {@link buildContentHubPublishedVideoDeepLink} with the grid block as section root.
 */
export function buildContentHubGridVideoShareUrl(params: {
  organizationExternalId?: string | null;
  pageSlug?: string | null;
  pageUrl?: string | null;
  getGridRootElement: () => HTMLElement | null | undefined;
  video: {
    id: string;
    title?: string | null;
  };
}): string {
  return buildContentHubPublishedVideoDeepLink({
    organizationExternalId: params.organizationExternalId,
    pageSlug: params.pageSlug,
    pageUrl: params.pageUrl ?? null,
    getSectionRootElement: params.getGridRootElement,
    videoId: params.video.id,
    videoName: params.video.title ?? null,
  });
}
